export const InstrumentationLabels = {
  ENVIRONMENTAL_CONDITION: "eh.iba.environmental_condition",
  SPECIAL_DEMANDS: "eh.iba.special_demands",
  CRITICALITY_QUALITY: "eh.iba.criticality_quality",
  CRITICALITY_ENVIRONMENT: "eh.iba.criticality_environment",
  CRITICALITY_SAFETY: "eh.iba.criticality_safety",
};
